import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE } from "../constant/appConstant";
import { resourceLanguage } from "../util/resourceLanguage";

i18next.use(initReactI18next).init({
  resources: resourceLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  react: { useSuspense: true },
});

export default i18next;